import Plugin from "@ckeditor/ckeditor5-core/src/plugin"
import Widget from "@ckeditor/ckeditor5-widget/src/widget"
import { toWidget } from "@ckeditor/ckeditor5-widget/src/utils"
import AppAffiliateTemplateCommand from "./appaffiliatetemplatecommand"

export default class AppAffiliateTemplateEditing extends Plugin {
  static get requires() {
    return [Widget]
  }

  init() {
    this.defineSchema()
    this.defineConverters()
    this.editor.commands.add(
      "insertAppAffiliateTemplate",
      new AppAffiliateTemplateCommand(this.editor)
    )
  }

  defineSchema() {
    const schema = this.editor.model.schema

    schema.register("appAffiliateTemplateBox", {
      isObject: true,
      allowWhere: "$block",
    })
    schema.register("appAffiliateTemplateLabel", {
      allowIn: "appAffiliateTemplateBox",
      allowContentOf: "$block",
    })
    schema.register("appAffiliateTemplateName", {
      isLimit: true,
      allowIn: "appAffiliateTemplateBox",
      allowContentOf: "$block",
      allowAttributes: ["id"],
    })
  }

  defineConverters() {
    const conversion = this.editor.conversion

    // <appAffiliateTemplateBox> converters
    conversion.for("upcast").elementToElement({
      model: "appAffiliateTemplateBox",
      view: {
        name: "div",
        classes: "app-affiliate-template-box",
      },
    })
    conversion.for("dataDowncast").elementToElement({
      model: "appAffiliateTemplateBox",
      view: {
        name: "div",
        classes: "app-affiliate-template-box",
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "appAffiliateTemplateBox",
      view: (modelElement, viewWriter) => {
        const div = viewWriter.createContainerElement("div", {
          class: "app-affiliate-template-box",
        })
        return toWidget(div, viewWriter, {
          label: "app affiliate template box",
        })
      },
    })

    // <appAffiliateTemplateLabel> converters
    conversion.elementToElement({
      model: "appAffiliateTemplateLabel",
      view: {
        name: "label",
        classes: "app-affiliate-template-label",
      },
    })

    // <appAffiliateTemplateName> converters
    conversion
      .for("upcast")
      .elementToElement({
        model: "appAffiliateTemplateName",
        view: {
          name: "h1",
          classes: "app-affiliate-template-name",
        },
      })
      .attributeToAttribute({
        view: "id",
        model: "id",
      })
    conversion.for("dataDowncast").elementToElement({
      model: "appAffiliateTemplateName",
      view: (modelElement, viewWriter) => {
        const h1 = viewWriter.createContainerElement("h1", {
          id: modelElement.getAttribute("id"),
          class: "app-affiliate-template-name",
        })
        return toWidget(h1, viewWriter, {
          label: "app affiliate template box",
        })
      },
    })
    conversion.for("editingDowncast").elementToElement({
      model: "appAffiliateTemplateName",
      view: (modelElement, viewWriter) => {
        // Note: You use a more specialized createEditableElement() method here.
        const h1 = viewWriter.createContainerElement("h1", {
          id: modelElement.getAttribute("id"),
          class: "app-affiliate-template-name",
        })
        // const h1 = viewWriter.createContainerElement( 'h1', { class: 'app-affiliate-template-name' } );
        return toWidget(h1, viewWriter)
      },
    })
  }
}
